
















































import _ from "lodash";
import { Component, Mixins, Vue } from "vue-property-decorator";
import CentralInsert from "@/components/miscellaneous/CentralInsert.vue";
import Configuration from "front-component/Configuration";
import Auth from "front-component/Auth";
import CommonAuthMixin from "@/mixins/auth/CommonAuthMixin";
const components = {
    CentralInsert,
};

@Component({ components })
export default class ForgottenPassword extends Mixins(CommonAuthMixin) {
    private email: string = "";
    private submitted: boolean = false;
    protected loading: boolean = false;

    private get disableSubmit(): boolean {
        return this.loading || this.submitted;
    }

    private triggerReset(): void {
        this.loading = true;
        const resetLocation = window.location.origin
            + this.$router.resolve({
                name: "reset_password",
                query: { token: "{{token}}" }
            }).href;

        Auth.forgottenPassword(
            Configuration.get("authUri"),
            Configuration.get("applicationId"),
            this.email,
            resetLocation
        ).then(() => {
            this.handleMessage("success", "forgottenEmailConfirm", true);
            this.submitted = true;
            this.loading = false;
            this.$router.push({ name: "home" });
        }).catch(() => {
            this.handleMessage("error", "forgottenEmailError", true);
            this.loading = false;
        });
    }
}
